export function isValidDuns(duns: string) {
    return /^[0-9]{9}$/.test(duns);
}

export function isWithoutDuplicates<T>(list: T[]) {
    return list.length === new Set(list).size;
}
